/**
 * Tailwind translations of the legacy block primitives from
 * app/static/js/site/creation-tools/components/blocks.ts. Only the
 * primitives an existing or upcoming consumer needs are ported here — the
 * rest follow when a consumer arrives.
 */

// Legacy: components/blocks.ts:5-12 (WrapperBlock)
export const wrapperBlock = 'flex min-h-[calc(100vh-70px)] w-full flex-col items-center justify-center'

// Legacy: components/blocks.ts:14-24 (ContainerBlock). BORDER_RADIUS_LARGE
// (packages/creation/src/creation-tools/constants.ts) is 6.
export const containerBlock =
    'relative m-0 mx-auto flex min-h-[500px] w-full rounded-[6px] bg-giphyBlack text-[17px] shadow-[0_11px_30px_rgba(0,0,0,0.5)]'

// Legacy: components/blocks.ts:46-61 (SplitBlock). Legacy expresses the
// child rules as a `> div` descendant selector; Tailwind has no clean
// equivalent, so `splitBlockColumn` is exported separately — apply it
// directly to every direct child of an element using `splitBlock`.
export const splitBlock = 'flex w-full rounded-[inherit]'
export const splitBlockColumn =
    'box-border min-w-0 w-full px-[30px] pt-[50px] pb-[30px] last:rounded-[inherit] last:bg-giphyDarkestGrey'

// Legacy: components/blocks.ts:63-71 (ColumnBlock). Legacy expresses the
// first-child rule as a `> div:first-child` descendant selector; Tailwind
// has no clean equivalent, so `columnBlockFirstChild` is exported
// separately — apply it directly to the first child of an element using
// `columnBlock`.
export const columnBlock = 'flex flex-col'
export const columnBlockFirstChild = 'h-full mb-[30px]'

// Legacy: components/blocks.ts:93-99 (OverlayBlock)
export const overlayBlock = 'absolute left-0 top-0 h-full w-full'

// Legacy: components/blocks.ts:101-109 (StickerBlock) — the transparency
// checkerboard, two offset 45deg gradients on a black ground.
export const stickerBlock =
    'bg-black bg-[length:24px_24px] bg-[position:0_0,12px_12px] ' +
    'bg-[image:linear-gradient(45deg,#0e0e0e_25%,transparent_25%,transparent_75%,#0e0e0e_75%),linear-gradient(45deg,#0e0e0e_25%,transparent_25%,transparent_75%,#0e0e0e_75%)]'

// Legacy: components/blocks.ts:111-115 (GridBlock). Legacy interpolates the
// column count into the CSS; Tailwind cannot see `grid-cols-${n}`, so the
// literal class names are enumerated. Only the counts actually used are
// mapped — an unmapped one throws rather than silently emitting no CSS.
// Legacy's track sizing is `repeat(N, 1fr)` (behaves as minmax(auto, 1fr)),
// not Tailwind's built-in `grid-cols-N` (`repeat(N, minmax(0, 1fr))`) — the
// two differ whenever a cell's content can't shrink to zero, so an
// arbitrary-value class reproduces legacy's track sizing exactly.
const gridColumns: Record<number, string> = {
    2: 'grid-cols-[repeat(2,1fr)]',
    4: 'grid-cols-[repeat(4,1fr)]',
    6: 'grid-cols-[repeat(6,1fr)]',
    7: 'grid-cols-[repeat(7,1fr)]',
}

export const gridBlock = (columns: number): string => {
    const columnClass = gridColumns[columns]
    if (!columnClass) {
        throw new Error(`gridBlock: grid-cols-${columns} is not in the literal class map — add it`)
    }
    return `grid gap-[10px] ${columnClass}`
}
